
  import {Component, Prop, Vue} from "vue-property-decorator";
  import VendorService from "../../services/vendor.service"
  import LoadingOverlay from "../core/LoadingOverlay.vue";
  import {Vendor} from "../../models/vendor";
  import Constants from "./../../staticdata/constants"

  @Component({
    components: {LoadingOverlay},
  })
  export default class CreateNewVendorEntryDialog extends Vue {

    @Prop({default: null})
    selectedVendor: Vendor

    private notEmptyRule = (v: string) => !!v || 'Feld muss ausgefüllt sein'

    private maxValueRule(maxValue: number, fieldName: string) {
      return (value: string) => (value && value.length <= maxValue) || fieldName + ' darf maximal '+ maxValue +' Zeichen enthalten';
    }

    private validateBIC(value: string) {
      const bicPattern = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
      return bicPattern.test(value) || 'Ungültiger BIC';
    }

    private validateIBAN(value: string) {
      const bicPattern = /^[A-Z]{2}\d{2}[A-Z0-9]{4,30}$/;
      return bicPattern.test(value) || 'Ungültige IBAN';
    }

    private showOverlay = false;

    private vendor: Vendor = {
      aimsId: '',
      type : Constants.VENDOR_TYPE_VENDOR
    };

    private isMemberVendor = true;

    private handleIsMemberVendorChange() {
      if (this.isMemberVendor) {
        this.vendor.type = Constants.VENDOR_TYPE_MEMBER;
      } else {
        this.vendor.aimsId = '';
        this.vendor.type = Constants.VENDOR_TYPE_VENDOR;
      }
    }

    get getAimsNumberRules() {
      if (this.isMemberVendor) {
        return [
          (v: string) => !v || /^\d+$/.test(v) || 'Nur Zahlen erlaubt',
          (v: string) => !!v || 'Feld muss ausgefüllt sein',
          (v: number) => !v || +v >= 10000 || 'Muss größer als 10000 sein',
        ];
      }
      else {
        return [];
      }
    }

    created() {
      if (this.selectedVendor != null) {
        //Edit
        this.vendor = JSON.parse(JSON.stringify(this.selectedVendor));
        //@ts-ignore
        if (this.vendor.bankAccounts.length == 0) {
          //@ts-ignore
          this.vendor.bankAccounts.push({});
        }
        this.isMemberVendor = this.selectedVendor.type == 'MEMBER' ? true: false;
      } else {
        //New
        this.vendor = {
          aimsId: '',
          type : Constants.VENDOR_TYPE_MEMBER
        };
        this.vendor.bankAccounts = [];
        this.vendor.bankAccounts.push({});
        this.vendor.type = Constants.VENDOR_TYPE_MEMBER;
      }
    }

    private createNewVendor() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {

        let callback = null;
        //edit?
        if (this.selectedVendor != null) {
          callback = VendorService.updateVendor(this.vendor);
        } else {
          callback = VendorService.createNewVendor(this.vendor);
        }

        callback
          .then(
            (response: any) => {
              this.$notify({
                group: 'foo',
                title: 'Info',
                text: response.data,
                type: 'success'
              });
              this.showOverlay = false;
              this.$emit('event');
            })
          .catch((error: any) => {
            this.$notify({
              group: 'foo',
              title: 'Fehler',
              text: error.response!.data,
              type: 'error'
            });
            this.showOverlay = false;
          })
          .finally(() => {
            setTimeout(() => {
              this.showOverlay = false;
            }, 500);
          });
      }
    }

    private addRowToBankAccountSet() {
      //@ts-ignore
      this.vendor.bankAccounts.push({});
    }

    private removeRowFromBankAccountSet(index: any) {
      //@ts-ignore
      this.vendor.bankAccounts.splice(index, 1);
    }

    private getMandatory(index: number) {
      if (index > 0) {
        return [this.notEmptyRule];
      } else {
        return [];
      }
    }

  }
